import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { Product } from '@/mocks/products';

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="product-card relative rounded-2xl overflow-hidden flex flex-col"
      style={{ background: '#1A2130' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Badge */}
      {product.badge && (
        <div className="absolute top-4 left-4 z-10 bg-accent px-3 py-1 rounded-full text-xs font-semibold text-white whitespace-nowrap">
          {product.badge}
        </div>
      )}

      {/* Image */}
      <Link
        to={`/product/${product.id}`}
        className="relative aspect-[4/3] overflow-hidden block cursor-pointer flex-shrink-0"
        style={{ background: '#FFFFFF' }}
      >
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover object-center transition-transform duration-500"
          style={{ transform: hovered ? 'scale(1.06)' : 'scale(1)' }}
        />
      </Link>

      {/* Content */}
      <div className="p-5 flex flex-col flex-1">
        <p className="text-accent text-xs font-medium tracking-wider uppercase mb-1.5">
          {product.category}
        </p>
        <Link
          to={`/product/${product.id}`}
          className="block font-poppins font-bold text-base text-white mb-2 leading-snug hover:text-accent transition-colors duration-200 cursor-pointer"
        >
          {product.name}
        </Link>
        <p className="text-text-muted text-sm leading-relaxed mb-3 line-clamp-2 flex-1">
          {product.benefit}
        </p>

        {/* Sizes */}
        <div className="flex flex-wrap gap-1.5 mb-4">
          {product.sizes.map((size) => (
            <span
              key={size}
              className="px-2.5 py-1 rounded-md text-xs font-medium whitespace-nowrap"
              style={{ background: 'rgba(255,255,255,0.06)', color: '#8A8FA8' }}
            >
              {size}
            </span>
          ))}
        </div>

        {/* Two Buttons */}
        <div className="flex gap-2 mt-auto">
          <Link
            to={`/product/${product.id}`}
            className="flex-1 flex items-center justify-center gap-1.5 py-2.5 rounded-xl text-sm font-semibold text-white cursor-pointer whitespace-nowrap transition-all duration-200 border border-white/15 hover:border-accent/50 hover:text-accent"
            style={{ background: 'rgba(255,255,255,0.05)' }}
          >
            <i className="ri-eye-line text-sm" />
            View Details
          </Link>
          <a
            href={`https://wa.me/923007321011?text=Hi%20Hamva%2C%20I%20am%20interested%20in%20${encodeURIComponent(product.name)}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex-1 wa-btn flex items-center justify-center gap-1.5 py-2.5 rounded-xl text-sm font-semibold text-white cursor-pointer whitespace-nowrap transition-all duration-300 ${hovered ? 'red-glow' : ''}`}
          >
            <i className="ri-whatsapp-line text-sm" />
            WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
